import { render, staticRenderFns } from "./PhaseBanner.vue?vue&type=template&id=4a36b4ae&"
import script from "./PhaseBanner.vue?vue&type=script&lang=js&"
export * from "./PhaseBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports